import { module as BaseModule } from "modujs";

const SELECTORS = {
  tab: "[data-state-tab]",
  item: "[data-state-item]",
};

export default class StateTabs extends BaseModule {
  init() {
    this.handleTabClick = this.handleTabClick.bind(this);
    this.tabs = Array.from(this.el.querySelectorAll(SELECTORS.tab));
    this.items = Array.from(this.el.querySelectorAll(SELECTORS.item));

    if (!this.tabs.length || !this.items.length) {
      return;
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick);
    });
  }

  destroy() {
    if (this.tabs) {
      this.tabs.forEach((tab) => {
        tab.removeEventListener("click", this.handleTabClick);
      });
    }

    this.tabs = [];
    this.items = [];
  }

  handleTabClick(event) {
    const tab = event.currentTarget;

    if (!tab) {
      return;
    }

    const slug = tab.getAttribute("data-state-tab");

    this.updateSelection(tab, slug);
  }

  updateSelection(selectedTab, slug) {
    this.clearSelection();

    if (selectedTab) {
      selectedTab.classList.add("is-selected");
    }

    if (!slug) {
      return;
    }

    const targetItem = this.items.find(
      (item) => item.getAttribute("data-state-item") === slug
    );

    if (targetItem) {
      targetItem.classList.add("is-selected");
    }
  }

  clearSelection() {
    this.tabs.forEach((tab) => tab.classList.remove("is-selected"));
    this.items.forEach((item) => item.classList.remove("is-selected"));
  }
}
